<template>
    <h1>First component of the UnCustomUI example.</h1>
</template>

<script>
export default {
  name: 'ExampleComponent1'
}
</script>

<style scoped>

</style>
